import { Injectable } from "@angular/core";
import { BaseService } from "../../shared/services/base.service";
import { UserUrl } from "../../shared/urls/user.url"

@Injectable()
export class ActiveLinkService {
    constructor(public baseService: BaseService) {
    }

    emailConfirm(data) {
        const url = UserUrl.EMAIL_CONFIRM_URL;
        return this.baseService.postData(url, data);
    }

    resendEmailConfirm(data) {
        const url = UserUrl.RESEND_CONFIRM_EMAIL_URL;
        return this.baseService.postData(url, data);
    }
 
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/active-link/active-link.service.ts